import { render, staticRenderFns } from "./FranquiciaHero.vue?vue&type=template&id=625fbe49&scoped=true&"
import script from "./FranquiciaHero.vue?vue&type=script&lang=js&"
export * from "./FranquiciaHero.vue?vue&type=script&lang=js&"
import style0 from "./FranquiciaHero.vue?vue&type=style&index=0&id=625fbe49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625fbe49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
